<div class="px-2">
  <div class="relative w-full">
    <iframe class="w-full h-[150px] xs:h-[200px] md:h-[400px]" width="" height="315"
    src="https://www.youtube.com/embed/MB1xjwpaE88?si=yGjeL-kmq1ytebLJ" frameborder="0" allowfullscreen></iframe>
  </div>
  <div class="container mx-auto">
    <div class="flex flex-row justify-between pt-14">
      <div class="w-full age-wrap flex flex-row flex-wrap">
        <div class="w-full  md:w-1/2 ">
          <h2 class="pb-4 flex"> <span class="font-bold text-gray-400 text-3xl pb-4 border-b">PREMISE</span></h2>
          <p class="text-lg pb-3">Amidst building a Mobile First World happened the seismic shift towards building an AI
            First World. Google, Amazon, Facebook, Microsoft and Tesla are exploding the industry with their moon-shot
            AI products. Can the Indian Innovators think ahead of them?</p>
          <p class="text-lg pb-3">Disrupt Kerala 2017 will focus on futuristic trends leading technology disruption. The
            event will push a diverse group of individuals Break their echo chamber and set a definitive direction for
            their future.</p>
          <p class="text-lg pb-3">The summit will showcase advancing trends in AI, Machine Learning, Artificial
            Intelligence, Blockchain, Mixed Reality and Internet of Things, among others. Participants will imbibe ideas
            from leading innovators, influential technologists, data scientists and founders who now lead Global
            Technology Disruption.</p>
        </div>
        <div class="w-full md:w-1/2 flex justify-end">
          <img src="assets/images/dk17/disruption-banner.png">
        </div>
      </div>
    </div>
  </div>
</div>
<div class="w-full p-6 md:p-12 bg-slate-200">
  <div class="container mx-auto">
    <h2 class="pb-4 flex"> <span class="font-bold text-gray-600 text-3xl pb-4 border-b">SPEAKERS </span></h2>
    <div class="grid  gap-4 md:gap-4 lg:gap-8 grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_2.showModal()">
          <figure class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/michael.jpg" alt="" />
          </figure>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr. Michael Gord</h2>
              <p class="text-neutral-400">Founder & CEO</p>
              <p class="text-neutral-600">MLG Blockchain Consulting </p>
            </div>
            <p>Michael is a blockchain developer at TD and the founder of Bitcoin Canada and the McGill Cryptocurrency
              Club</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_1.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/venkat.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr. Venkatramanan P.R</h2>
              <p class="text-neutral-400">Data Scientist</p>
              <p class="text-neutral-600">Thought Works </p>
            </div>
            <p>Venkat is Lead Consultant and Data Scientist at ThoughtWorks. Over the last few years, he has helped
              build...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_3.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/satish-babu.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr. Satish Babu</h2>
              <p class="text-neutral-400">Chair, APRALO</p>
              <p class="text-neutral-600">ICANN </p>
            </div>
            <p>Programmer, Development Professional and Internet Governance Practitioner, associated...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_4.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/nandini.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Professor Nandini Vaidyanathan</h2>
              <p class="text-neutral-400">Chairman and Managing Director</p>
              <p class="text-neutral-600">CARMa Venture Services </p>
            </div>
            <p>She’s a traveling teacher who specialises in entrepreneurship, in several...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_5.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/rama-brahmam.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr. Rama Brahmam Aleti</h2>
              <p class="text-neutral-400">Co-Founder & UX Strategist</p>
              <p class="text-neutral-600">Think Design Collaborative </p>
            </div>
            <p>As a Co-founder & Director - Experience Design, at Think Design Collaborative, Rama has been
              instrumental...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_6.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/abhilash-ashok.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr. Abhilash Ashok </h2>
              <p class="text-neutral-400">Senior Lead, UX Development</p>
              <p class="text-neutral-600">Valorem </p>
            </div>
            <p>An Incorruptible Passionate Microsoft Technology Stack Enthusiast with rich 8+ years...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_7.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/sanju-mathew.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr. Sanju Mathew</h2>
              <p class="text-neutral-400">CEO</p>
              <p class="text-neutral-600">Onbyz </p>
            </div>
            <p>anju Mathew is an Mtech Electronics graduate (Signal Processing and Bionics)...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_8.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/anivar.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr. Anivar Aravind</h2>
              <p class="text-neutral-400">Founder Executive Director</p>
              <p class="text-neutral-600">Indic Project </p>
            </div>
            <p>Anivar A. Aravind is Founder Executive Director of Indic Project a civic-tech non-profit,...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_9.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/rafi.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr. Mohammed Rafi T.F</h2>
              <p class="text-neutral-400">Behavioural Scientist, Life... </p>
              <p class="text-neutral-600 mb-2">Neuro Lingusitic Programme </p>
            </div>
            <p>A Behavioural Scientist, Life Transformation Specialist and
              International Master...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_10.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/manuyash-chaudhary.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr. Manuyash Chaudhary</h2>
              <p class="text-neutral-400">AI & NLP Developer & Researcher</p>
              <p class="text-neutral-600 mb-2">Accubits</p>
            </div>
            <p>Mr. Manuyash Chaudhary works as AI & NLP Developer & Researcher,
              Accubits Technologies...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="w-full p-6 md:p-12 g-slate-100">
  <div class="container mx-auto">
    <h2 class="pb-4 flex"> <span class="font-bold text-gray-600 text-3xl pb-4 border-b">PANELLISTS </span></h2>
    <div class="grid  gap-4 md:gap-4 lg:gap-8 grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_11.showModal()">
          <figure class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/sivasankar.jpg" alt="" />
          </figure>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr. M Sivasankar IAS</h2>
              <p class="text-neutral-400">IT Secretary</p>
              <p class="text-neutral-600">Government of Kerala </p>
            </div>
            <p>Shri. M Sivasankar is presently the Secretary to Government, IT Department..</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_2.showModal()">
          <figure class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/michael.jpg" alt="" />
          </figure>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr. Michael Gord</h2>
              <p class="text-neutral-400">Founder & CEO</p>
              <p class="text-neutral-600">MLG Blockchain Consulting </p>
            </div>
            <p>Michael is a blockchain developer at TD and the founder of Bitcoin Canada and the McGill Cryptocurrency
              Club</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_4.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/nandini.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Professor Nandini Vaidyanathan</h2>
              <p class="text-neutral-400">Chairman and Managing Director</p>
              <p class="text-neutral-600">CARMa Venture Services </p>
            </div>
            <p>She’s a traveling teacher who specialises in entrepreneurship, in several...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_13.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/ashraf.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Dr. Asharaf S</h2>
              <p class="text-neutral-400">Associate Professor</p>
              <p class="text-neutral-600">IIITMK </p>
            </div>
            <p>Asharaf S is an Associate Professor at Indian Institute of
              Information Technology...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_14.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/rahul.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr Rahul Alex Panicker</h2>
              <p class="text-neutral-400">Co-founder and President</p>
              <p class="text-neutral-600">Embrace Innovations </p>
            </div>
            <p>A technology product leader, Mr. Panicker loves building and leading creative teams...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_15.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/aswin.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr Aswin P</h2>
              <p class="text-neutral-400">Program Manager</p>
              <p class="text-neutral-600">Frost Sullivan's Middle East</p>
            </div>
            <p>Aswin Kumar is Program Manager with the Mobility (Automotive & Transportation) Practice..</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 overflow-hidden">
        <a onclick="my_modal_16.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/anoop.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Anoop Ambika</h2>
              <p class="text-neutral-400">Founder</p>
              <p class="text-neutral-600">CLAP Research</p>
            </div>
            <p>Anoop P Ambika is a serial entrepreneur, organiser and a
              technology enthusiast. He is the co-founder..</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="w-full p-6 md:p-12 bg-slate-50">
  <div class="container mx-auto">
    <div class="border-b border-gray-300 pb-5 mb-5">
      <h2 class="pb-4 flex"> <span class="font-bold text-gray-600 text-3xl pb-4 border-b">Travancore Hall (Park
          Center)</span></h2>
      <div class="flex flex-wrap">
        <div class="w-full lg:w-1/4">
          <img src="assets/images/dk17/travancore-hall.png">
        </div>
        <div class="w-full lg:w-3/4">
          <ul>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">9:00AM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">Registration</div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">9:30AM - 10:00AM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">Inauguration</div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">10:00AM - 11:00AM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Keynote: Tech Disruption – Opportunities & Threats </p>
                <p>Mr. Michael Gord (Founder & CEO - MLG Blockchain Consulting)</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">11:00AM - 11:15AM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">Tea Break</div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">11:15AM - 12:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">FOSS - Role of communities </p>
                <p>Mr. Satish Babu (Chair, APRALO - ICANN) </p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">12:00PM - 1:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Designing Machine Learning Systems</p>
                <p>Mr. Venkatramanan P. R. (Data Scientist - Thoughtworks) </p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">1:00PM - 2:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>Networking Lunch</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">2:00PM - 3:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">How to Grow Faster & Smarter in the Age of Disruption</p>
                <p>Prof. Nandini Vaidyanathan (Chairman and Managing Director - CARMa Venture Services) </p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">03:00PM - 3:40PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">UX at the Age of Disruption </p>
                <p>Mr. Rama Brahmam Aleti (Co-Founder & UX Strategist) </p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">3:40PM - 4:40PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Panel Discussion - Staying Relevant at the Age of Disruption</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">4:40PM - 5:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>Tea</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">5:00PM - 6:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p>Valedictory function - Official Launch of FAYA:80 Kochi & Kozhikode</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="border-b border-gray-300 pb-5 mb-5">
      <h2 class="pb-4 flex"> <span class="font-bold text-gray-600 text-3xl pb-4 border-b">Travancore Hall (Park
          Center)</span></h2>
      <div class="flex flex-wrap">
        <div class="w-full lg:w-1/4">
          <img src="assets/images/dk17/start-up.jpg">
        </div>
        <div class="w-full lg:w-3/4">
          <ul>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">11:15AM - 12:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Software & Hardware Breakthroughs in Bionics and IOT</p>
                <p>Mr. Sanju Mathew (CEO - Onbyz)</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">12:00PM - 1:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold"> TVR, AR & MR: What’s Real, What’s Now, What’s to Come</p>
                <p>Mr. Abhilash Ashok (Senior Lead UX Development - Valorem)</p>
              </div>

            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">2:00PM - 4:30PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Get your ‘Hands-On’ Block Chain!</p>
                <p>Mr. Jikku Jose</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="border-b border-gray-300 pb-5 mb-5">
      <h2 class="pb-4 flex"> <span class="font-bold text-gray-600 text-3xl pb-4 border-b">Malabar Hall (Park)</span>
      </h2>
      <div class="flex flex-wrap">
        <div class="w-full lg:w-1/4">
          <img src="assets/images/dk17/malabar-hall.png">
        </div>
        <div class="w-full lg:w-3/4">
          <ul>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">11:15AM - 12:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Fairness in Civic Technologies</p>
                <p>Mr. Anivar Aravind (Founder Executive Director, Indic Project)</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">12:00PM - 1:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Decoding Phantoms in the Brain Using Technology</p>
                <p>Mr. Mohammed Rafi T. F. (Behavioural Scientist)</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">2:00PM - 4:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Build your First VR Mobile App with Unity</p>
                <p>Mr. Dileep P.G, Mr. Nithin Jose</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="border-b border-gray-300 pb-5 mb-5">
      <h2 class="pb-4 flex"> <span class="font-bold text-gray-600 text-3xl pb-4 border-b">Floor of Madness, FAYA</span>
        <br><span class="font-bold text-gray-600 text-3xl pb-4 border-b">(Thejaswini)</span></h2>
      <div class="flex flex-wrap">
        <div class="w-full lg:w-1/4">
          <img src="assets/images/dk17/faya.jpg">
        </div>
        <div class="w-full lg:w-3/4">
          <ul>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">11:15AM - 1:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Soft Computing and Blockchain in Bioinformatics</p>
                <p>Mr. Manuyash Chaudhary, Mr. Rahul A. R. (Accubits Technologies)</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">2:00PM - 4:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p> Intelligent Computing in Bio Systems</p>
                <p>Mr. Charush S. Nair, Mr. Jithin V. G. ( Accubits Technologies)</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="border-b border-gray-300 pb-5 mb-5">
      <h2 class="pb-4 flex"> <span class="font-bold text-gray-600 text-3xl pb-4 border-b">Exhibition Hall, Park
          Centre</span></h2>
      <div class="flex flex-wrap">
        <div class="w-full lg:w-1/4">
          <img src="assets/images/dk17/park-centre.jpg">
        </div>
        <div class="w-full lg:w-3/4">
          <ul>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">11:15AM - 1:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Speach Enabled Kinematics - Bionic Hand Demo</p>
                <p>(Onbyz Team)</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm">2:00PM - 4:00PM</div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Experience VR, AR & MR, Live Demo</p>
                <p>(Valorem Team)</p>
              </div>

            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="w-full p-6 md:p-12 ">
  <div class="container mx-auto">
    <div class="flex flex-wrap">
      <div class="flex w-full md:w-1/2 flex-col items-center">
        <h2 class="pb-4 border-b mb-4 md:mb-9 "> <span class="font-bold text-gray-600 text-3xl flex">PARTNERS </span>
        </h2>
        <div class="flex items-center justify-center gap-6">
          <div><img src="assets/images/dk17/sponsers-icfoss.png"></div>
          <div><img src="assets/images/dk17/sponsers-startup-mission.png"></div>
        </div>

      </div>
      <div class="flex w-full md:w-1/2 flex-col items-center">
        <h2 class="pb-4 border-b mb-4 md:mb-9 "> <span class="font-bold text-gray-600 text-3xl flex">Sponsors </span>
        </h2>
        <div class="flex items-center justify-center gap-6">
          <div class="text-center flex items-center flex-col">
            <img src="assets/images/dk17/xoxo.jpg">
            <p>Rewards & Recognition Partner</p>
          </div>
          <div class="text-center flex items-center flex-col">
            <img src="assets/images/dk17/sponsers-apollo-dimora.jpg">
            <p>Hospitality Partner </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div class="w-full p-12 bg-slate-50">
  <div class="container mx-auto max-w-screen-xl">
    <div class="carousel w-full">
      <div id="slide01" class="carousel-item relative w-full">
        <img src="assets/images/dk17/slider/PORT80-TIMELINE1.jpg" class="w-full" />
        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide07" class="btn btn-circle">❮</a>
          <a href="#slide02" class="btn btn-circle">❯</a>
        </div>
      </div>
      <div id="slide02" class="carousel-item relative w-full">
        <img src="assets/images/dk17/slider/PORT80-TIMELINE2.jpg" class="w-full" />
        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide01" class="btn btn-circle">❮</a>
          <a href="#slide03" class="btn btn-circle">❯</a>
        </div>
      </div>
      <div id="slide03" class="carousel-item relative w-full">
        <img src="assets/images/dk17/slider/PORT80-TIMELINE3.jpg" class="w-full" />
        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide02" class="btn btn-circle">❮</a>
          <a href="#slide04" class="btn btn-circle">❯</a>
        </div>
      </div>
      <div id="slide04" class="carousel-item relative w-full">
        <img src="assets/images/dk17/slider/PORT80-TIMELINE4.jpg" class="w-full" />
        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide03" class="btn btn-circle">❮</a>
          <a href="#slide05" class="btn btn-circle">❯</a>
        </div>
      </div>
      <div id="slide05" class="carousel-item relative w-full">
        <img src="assets/images/dk17/slider/PORT80-TIMELINE5.jpg" class="w-full" />
        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide04" class="btn btn-circle">❮</a>
          <a href="#slide06" class="btn btn-circle">❯</a>
        </div>
      </div>
      <div id="slide06" class="carousel-item relative w-full">
        <img src="assets/images/dk17/slider/PORT80-TIMELINE6.jpg" class="w-full" />
        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide05" class="btn btn-circle">❮</a>
          <a href="#slide07" class="btn btn-circle">❯</a>
        </div>
      </div>
      <div id="slide07" class="carousel-item relative w-full">
        <img src="assets/images/dk17/slider/PORT80-TIMELINE7.jpg" class="w-full" />
        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide06" class="btn btn-circle">❮</a>
          <a href="#slide01" class="btn btn-circle">❯</a>
        </div>
      </div>
    </div>
  </div>
</div> -->

<dialog id="my_modal_1" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/venkat.jpg" alt="" /></div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Venkatramanan P.R</h2>
        <p class="text-neutral-400">Data Scientist</p>
        <p class="text-neutral-600 mb-2">Thought Works</p>
        <p class="text-slate-600 text-sm leading-6">Venkat is Lead Consultant and Data Scientist at ThoughtWorks. Over
          the last few years, he has helped build the data science capability within ThoughtWorks India, and worked with
          clients across several industries to deliver data science solutions. Before this, he used to work as a
          Physicist, working primarily in the field of phase transitions in Soft Condensed Matter systems.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_2" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/michael.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Michael Gord</h2>
        <p class="text-neutral-400">Founder & CEO</p>
        <p class="text-neutral-600 mb-2">MLG Blockchain Consulting</p>
        <p class="text-slate-600 text-sm leading-6">Michael is a blockchain developer at TD and the founder of Bitcoin
          Canada and the McGill Cryptocurrency Club. While at McGill, Michael organized the Bitcoin Airdrop events where
          he gave hundreds of students their first bitcoin</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_3" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/satish-babu.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Satish Babu</h2>
        <p class="text-neutral-400">Chair, APRALO</p>
        <p class="text-neutral-600 mb-2">ICANN</p>
        <p class="text-slate-600 text-sm leading-6">Programmer, Development Professional and Internet Governance
          Practitioner, associated with ICANN, ISOC, IEEE and InApp. Fellow and former President of Computer Society of
          India. Chair, APRALO, ICANN and Member, 2017 HAC, IEEE.</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_4" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/nandini.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Professor Nandini Vaidyanathan</h2>
        <p class="text-neutral-400">Chairman and Managing Director</p>
        <p class="text-neutral-600 mb-2">CARMa Venture Services</p>
        <p class="text-slate-600 text-sm leading-6 mb-2">She’s a traveling teacher who specialises in entrepreneurship,
          in several Ivy League business schools around the world.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">After 20 years in the corporate sector, working in MNC-s
          in all inhabited continents, she returned to India in 2005 and
          began teaching entrepreneurship. Realizing that the only way she could bring real time experience to her
          classroom was if she became an entrepreneur herself, she founded CARMa (Creating Access to Resources &
          Markets; www.carmaconnect.in) with a lofty ambition: to offer professional mentoring to entrepreneurs as a
          risk mitigating strategy. CARMa mentors start-ups, mature enterprises and family businesses. As on date, CARMa
          has mentored over 2000 entrepreneurs. CARMa has also been involved in mentoring women to scale from livelihood
          enterprises to opportunity-based and profitable organizations in Afghanistan, South and East Africa and India.
          Till date over 10,000 women have been mentored to build scalable and profitable enterprises.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">
          A prolific writer for mainstream newspapers, portals and blogs, her first book Entrepedia: A Step by Step
          Guide to Becoming an Entrepreneur in India, has been a best-seller since its launch in 2011. Its second
          edition, updated and contemporized, came out in 2015 and has become the Bible of the start-up community. Her
          second book, Start up, Stand up, was published in 2016. While Entrepedia was all about how to take an idea
          from your head to the marketplace, Start up, Stand up is about how to grow your business from your first
          paying customer to an evangelical user community.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">
          A TED speaker and regular jury member of television shows on business channels and entrepreneurship events
          across the world, she was named Business Woman of the Year by Business Goa in 2014.
        </p>
        <p class="text-slate-600 text-sm leading-6">
          Passionate about cooking and entertaining people, her versatility extends to the Carnatic form of music in
          which she is a trained singer. She currently lives in Goa.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_5" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/rama-brahmam.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Rama Brahmam Aleti</h2>
        <p class="text-neutral-400">Co-Founder & UX Strategist</p>
        <p class="text-neutral-600 mb-2">Think Design Collaborative </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">As a Co-founder & Director - Experience Design, at Think Design
          Collaborative, Rama has been instrumental in developing the company into a leading, world-class UX Design and
          Innovation Consultancy. As part of the core team, Rama helps in driving the company's strategy, business and
          mentor its overall growth. He heads a team of over 90 Designers and has implemented 200+ UX projects in
          multiple domains such as - Finance, Education, Healthcare, Telecom, E-Commerce, and Entertainment. The
          companies
          include several Fortune companies, MNCs and startups.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">In addition to leading the practice at Think Design, Rama also
          conducts workshops on Design Thinking, Experience Design & Innovation. Rama is a regular speaker for Product
          Conclave at NASSCOM Events; a warm association that has seen him conducts six such workshops. He has also been
          invited by IIM-A, Indian School of Business (ISB), Unicom and conducted numerous Design workshops within
          India, North America and South America.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">
          Rama recommends initiating Design through workshop/s by inviting all stakeholders who can participate and
          hence collaborate in the solutioning process. He believes ‘Design Driven Innovation’ is the future and is
          certain that most of the businesses in this connected world will use it as a tool to stay ahead in business
          and innovation.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">
          Rama is a Post Graduate from the prestigious National Institute of Design (NID) after doing his Graduation in
          Applied Arts from Jawaharlal Nehru Technological University (JNTU). An ardent Design background is what
          enables Rama to extend his expertise to Strategic Design, Experience Design and Design Thinking.
        </p>
        <p class="text-slate-600 text-sm leading-6">
          On a personal front, he loves his South Indian delicacies, is an avid movie enthusiast, a great fan of Indian
          films, especially his regional Telugu movies. Even whilst pursuing his geeky inclinations, he loves spending
          time with his family, particularly, playing with his daughter and watching her grow up.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_6" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/abhilash-ashok.jpg"
          alt="" /></div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Abhilash Ashok</h2>
        <p class="text-neutral-400">Senior Lead, UX Development</p>
        <p class="text-neutral-600 mb-2">Valorem </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">An Incorruptible Passionate Microsoft Technology Stack
          Enthusiast with rich 8+ years’ experience, well-versed with Windows 10/UWP, Xamarin, WPF, HoloLens, Windows
          Phone/ Store/RT, Kinect for Windows, Xbox, Unity 3D, and legacy technologies like ASP.NET, Silverlight, ExtJS,
          WinForms, etc. He’s a prominent speaker in Microsoft Technology Community mainly K-MUG.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">He completed graduation in Computer Engineering from Mahatma
          Gandhi University in 2007. He’s working as Technical Team Lead at Identitymine – a UX Strategy expert company,
          working close with Microsoft, where he’s responsible for developing premium apps and services with cutting
          edge technologies. Besides development, he loves mentoring & building enthusiastic team. He finds himself
          lucky enough to work close with MVPs and Microsoft Regional Directors.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">He also has solid experience in airline domain, telecom domain,
          software and services; combined with proven experience in product life cycle, product quality, envisioning
          features, development and implementation. He had received various awards and laurels for his proven
          performance.
          He writes about “Nerds False Positive” in his blog – CameTooFar (http://cametoofar.com/) and tweets at
          https://twitter.com/abhilashca. </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_7" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/sanju-mathew.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Sanju Mathew</h2>
        <p class="text-neutral-400">CEO</p>
        <p class="text-neutral-600 mb-2">Onbyz </p>
        <p class="text-slate-600 text-sm leading-6">Sanju Mathew is an Mtech Electronics graduate (Signal
          Processing and Bionics), Entrepreneur, Intel IoT Innovator and a speaker at National and International
          conferences on Bionics and IoT. He is an Electronics Hardware Engineer, System Architect and UI/UX designer by
          choice with over 7 years of experience in these fields. His work includes a Predictive Maintenance AI for
          Airports (Australia), Water Supply Automation system for star hotels (USA) and Laser Calibration unit for
          Spectroscopy units (USA). His team built a Low Cost Bionic Hand for the disabled that focuses on modularity of
          sensors, custom designed feedback systems, powerful and low footprint microprocessor unit and a software
          architecture that makes use of Marketplace and community driven app development. Projects realized by his team
          was selected twice as top 10 in the world by Intel and was invited to present it at Intel Developer Forum 2015
          and 2016 at San Francisco, USA. His team was awarded the runners-up prize for Mastermind competition by Dr. A
          P J Abdul Kalam and was one of the winners for National Level Intel IoT Hackathon 2015.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_8" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/anivar.jpg" alt="" /></div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Anivar Aravind</h2>
        <p class="text-neutral-400">Founder Executive Director</p>
        <p class="text-neutral-600 mb-2">Indic Project </p>
        <p class="text-slate-600 text-sm leading-6">Anivar A. Aravind is Founder Executive Director of Indic Project, a
          civic-tech non-profit initiative works on language engineering, technology standards and digital rights.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_9" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/rafi.jpg" alt="" /></div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Mohammed Rafi T.F</h2>
        <p class="text-neutral-400">Behavioural Scientist, Life Transformation Specialist and International Master
          Trainer</p>
        <p class="text-neutral-600 mb-2">Neuro Lingusitic Programme </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">A Behavioural Scientist, Life Transformation Specialist and
          International Master Trainer in Neuro Lingusitic Programme with more than 13 years of experience in various
          streams ranging from Information Technology to Education to Retail and Insurance.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">Have heart fully trained more than 100 thousand people ranging
          from CEO’s to Celebrities to Billion Dollar Entrepreneurs. Was instrumental in coaching and mentoring senior
          managers and CEO’s of Corporate, Government, Private Sector and NGO’s to bring out the best in them and
          achieve excellence in their respective fields. A creative professional who applies his heart and soul into any
          assignment that he takes, and transforms the lives of those he comes across in his training programs and one
          to one coaching sessions.</p>
        <p class="text-slate-600 text-sm leading-6 mb-2">He is one of the only two trainers from Asia to be directly
          mentored by NLP Co-Creator Dr.John Grinder. He is also the Peak performance coach for Indian Junior Girls
          Gymnastics team and he is the personal NLP Coach for the National Award Winning Malayalam Actor Jayasurya.
          Some of Rafi’s esteemed clients include Organizations like Coca Cola, Lupin Pharma, Allianz Group, Reliance
          Industries, E&amp;Y;, LIC and many more. Currently he is pursuing research in Behavioural Neuropsychology,
          NLP,
          Micro Expression Patterns and Provocative Coaching.</p>
        <div>
          <h3 class="text-lg font-bold mb-2">Educational Competency: </h3>
          <ul>
            <li class="text-slate-600 text-sm list-disc ml-3">Master in Human Resource Management</li>
            <li class="text-slate-600 text-sm list-disc ml-3">Researcher in Behavioural Neuropsychology Certified
              International NLP Master Trainer.</li>
            <li class="text-slate-600 text-sm list-disc ml-3">Certified Peak Performance and Behavioural Trainer.</li>
            <li class="text-slate-600 text-sm list-disc ml-3">Certified Fire Walk Trainer.</li>
            <li class="text-slate-600 text-sm list-disc ml-3">Sales Mastery Expert.</li>
            <li class="text-slate-600 text-sm list-disc ml-3">Certified Provocative Therapy Practitioner.</li>
            <li class="text-slate-600 text-sm list-disc ml-3"> Integral Eye Movement Therapy Advanced Practitioner.</li>
            <li class="text-slate-600 text-sm list-disc ml-3">1 year Management development program from School of
              Communication and Management Studies</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_10" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/manuyash-chaudhary.jpg"
          alt="" /></div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Manuyash Chaudhary</h2>
        <p class="text-neutral-400">AI & NLP Developer & Researcher</p>
        <p class="text-neutral-600 mb-2">Accubits </p>
        <p class="text-slate-600 text-sm leading-6">Mr. Manuyash Chaudhary works as AI & NLP Developer & Researcher,
          Accubits Technologies. An MS in Machine Learning & Artificial Intelligence from University College London,
          Manuyash has been instrumental for path-breaking research on Data Science and its implementation during his
          career. He is responsible for developing AI technologies and solving machine learning problems for clients at
          Accubits. He works in Python and R, on platforms like Tensorflow, H2O.ai and tools like SPSS, WEKA and
          Tableau.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_11" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/sivasankar.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. M Sivasankar IAS</h2>
        <p class="text-neutral-400">IT Secretary</p>
        <p class="text-neutral-600 mb-2">Government of Kerala </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">Shri. M Sivasankar is presently the Secretary to Government, IT
          Department since June, 2016. He is also holding the charge of Officer on Special Duty to the Chief Minister of
          Kerala.
        </p>
        <p class="text-slate-600 text-sm leading-6">Sivasankar an Engineering Graduate and a Master of Business
          Administration (MBA) started his career as an officer in the Reserve Bank of India. He was subsequently
          appointed as Deputy Collector to the Government. While in service he was selected to the Indian Administrative
          Service (IAS) in 1995 which is the highest bureaucratic position in administrative service of India.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_12" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/sivasankar.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. M Sivasankar IAS</h2>
        <p class="text-neutral-400">IT Secretary</p>
        <p class="text-neutral-600 mb-2">Government of Kerala </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">Shri. M Sivasankar is presently the Secretary to Government, IT
          Department since June, 2016. He is also holding the charge of Officer on Special Duty to the Chief Minister of
          Kerala.
        </p>
        <p class="text-slate-600 text-sm leading-6">Sivasankar an Engineering Graduate and a Master of Business
          Administration (MBA) started his career as an officer in the Reserve Bank of India. He was subsequently
          appointed as Deputy Collector to the Government. While in service he was selected to the Indian Administrative
          Service (IAS) in 1995 which is the highest bureaucratic position in administrative service of India.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_13" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/ashraf.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Dr. Asharaf S</h2>
        <p class="text-neutral-400">Associate Professor</p>
        <p class="text-neutral-600 mb-2">IIITMK</p>
        <p class="text-slate-600 text-sm leading-6">Asharaf S is an Associate Professor at Indian Institute of
          Information Technology and Management – Kerala. He is also serving as a visiting faculty in Indian Institute
          of Space Science and Technology, Trivandrum and as a Mentor in Kerala Startup Mission. He received his PhD and
          Master of Engineering degrees in Computer Science from Indian Institute of Science, Bangalore. He graduated in
          Computer Engineering from Cochin University of Science and Technology. After his PhD he has worked with
          America Online (AOL) and IIM Kozhikode. He is a recipient of IBM outstanding PhD student award 2006, IBM
          Shared University Research Grant 2015 and IBM OSCP Grant 2017. He has published three books and more than 30
          research papers in international journals and conferences. His areas of interest include technologies and
          business models related to machine learning, web mining, intelligent internet of things and blockchains.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_14" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/rahul.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr Rahul Alex Panicker</h2>
        <p class="text-neutral-400">Co-founder and President</p>
        <p class="text-neutral-600 mb-2">Embrace Innovations </p>
        <p class="text-slate-600 text-sm leading-6">A technology product leader, Mr. Panicker loves building and leading
          creative teams to actualize magical products. He spends his time with users, working with designers,
          engineers, marketers, and sales folks to create these products, and taking them to market, giving them lots of
          TLC, and having their magic spread. As co-founder and president of Embrace, which has helped over 250,000
          vulnerable babies in the developing world, since 2012, his next mission is to transform the world through AI.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_15" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/aswin.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr Aswin P</h2>
        <p class="text-neutral-400">Program Manager</p>
        <p class="text-neutral-600 mb-2">Frost Sullivan's Middle East</p>
        <p class="text-slate-600 text-sm leading-6">Aswin Kumar is Program Manager with the Mobility (Automotive &
          Transportation) Practice for Frost Sullivan's Middle East, North Africa and South Africa region He has over
          eight years of BusIness Research and Strategy Consulting experience, which Include over 50 research and
          consulting projects. His expertise lies in Urban Technology Convergence, Telematics, Business Analysis, Market
          Entry, Geographical Expansion, Strategic Planning, Pricing Strategy, New Product Launch, Business Modelling
          and Planning, and After Market & OE Strategies. </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_16" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/anoop.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Anoop Ambika</h2>
        <p class="text-neutral-400">Founder</p>
        <p class="text-neutral-600 mb-2">CLAP Research</p>
        <p class="text-slate-600 text-sm leading-6 mb-3">Anoop P Ambika is a serial entrepreneur, organiser and a
          technology enthusiast. He is the co-founder of several technology/ environment startups and currently is Chief
          Executive
          Officer of CLAP Research and Genpro Life Sciences. </p>
        <p class="text-slate-600 text-sm leading-6">CLAP Research brings together a team of Machine Learning,
          Statistics, NLP and Cognitive Neuroscience specialists to enable the transition of enterprise applications
          from deterministic systems to implicit learning systems. </p>
      </div>
    </div>
  </div>
</dialog>
